export const FETCH_INVENTORY_REQUESTED = 'FETCH_INVENTORY_REQUESTED';
export const FETCH_INVENTORY_SUCCEEDED = 'FETCH_INVENTORY_SUCCEEDED';
export const MAP_DESTINATION_TO_PRODUCT_LOCATION = 'MAP_DESTINATION_TO_PRODUCT_LOCATION';
export const FETCH_INVENTORY_LOCATION_REQUESTED = 'FETCH_INVENTORY_LOCATION_REQUESTED';
export const FETCH_INVENTORY_DESTINATION_REQUESTED = 'FETCH_INVENTORY_DESTINATION_REQUESTED';
export const UPDATE_INVENTORY_DESTINATION = 'UPDATE_INVENTORY_DESTINATION';
export const UPDATE_INVENTORY_LOCATION_SUCCEEDED = 'UPDATE_INVENTORY_LOCATION_SUCCEEDED';
export const BULK_UPDATE_INVENTORIES_LOCATION_REQUESTED = 'BULK_UPDATE_INVENTORIES_LOCATION_REQUESTED';
export const BULK_UPDATE_INVENTORIES_LOCATION_SUCCEEDED = 'BULK_UPDATE_INVENTORIES_LOCATION_SUCCEEDED';
export const SELECT_INVENTORY_REQUESTED = 'SELECT_INVENTORY_REQUESTED';
export const SELECT_INVENTORY = 'SELECT_INVENTORY';
export const FETCH_BULK_INVENTORIES_REQUESTED = 'FETCH_BULK_INVENTORIES_REQUESTED';
export const FETCH_BULK_INVENTORIES_SUCCEEDED = 'FETCH_BULK_INVENTORIES_SUCCEEDED';
export const SELECT_ALL_ITEMS = 'SELECT_ALL_ITEMS';
export const FILTER_INVENTORY_REQUESTED = 'FILTER_INVENTORY_REQUESTED';
export const FILTER_INVENTORY_SUCCEEDED = 'FILTER_INVENTORY_SUCCEEDED';
export const UPDATED_DESTINATION_LOCATIONS_REQUESTED = 'UPDATED_DESTINATION_LOCATIONS_REQUESTED';
export const UPDATE_INVENTORY_FILTER = 'UPDATE_INVENTORY_FILTER';
export const PRE_FILL_FILTER_FILTER = 'PRE_FILL_FILTER_FILTER';
export const SEARCH_INVENTORY_REQUESTED = 'SEARCH_INVENTORY_REQUESTED';
export const INVENTORY_UPDATE_PRODUCT_DESTINATION = 'INVENTORY_UPDATE_PRODUCT_DESTINATION';
export const INVENTORY_UPDATE_PRODUCT_LOCATION = 'INVENTORY_UPDATE_PRODUCT_LOCATION';
export const INVENTORY_SAVE_PRODUCT_LOCATION = 'INVENTORY_SAVE_PRODUCT_LOCATION';
export const INVENTORY_SAVE_PRODUCT_LOCATION_SUCCEEDED = 'INVENTORY_SAVE_PRODUCT_LOCATION_SUCCEEDED';
export const NO_PRODUCT_LOCATION_FOUND = 'NO_PRODUCT_LOCATION_FOUND';
export const ADD_PENDING_PRODUCT = 'ADD_PENDING_PRODUCT';
export const REMOVE_PENDING_PRODUCT = 'REMOVE_PENDING_PRODUCT';
export const ADD_PRODUCT_TO_INVENTORY = 'ADD_PRODUCT_TO_INVENTORY';
export const SELECT_DESTINATION_OF_PENDING_PRODUCT = 'SELECT_DESTINATION_OF_PENDING_PRODUCT';
export const SELECT_LOCATION_OF_PENDING_PRODUCT = 'SELECT_LOCATION_OF_PENDING_PRODUCT';
export const FETCH_PRODUCT_LOCATION_LAST_TRACK_SUCCEEDED = 'FETCH_PRODUCT_LOCATION_LAST_TRACK_SUCCEEDED';
